import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ep-head" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    (_ctx.$store.state.user.logoPath)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.$store.state.apiUrl + _ctx.$store.state.spacesUrl + _ctx.$store.state.user.logoPath,
          alt: ""
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "ep-meta",
      title: "Edit details",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open')))
    }, [
      _createElementVNode("div", null, [
        _cache[1] || (_cache[1] = _createElementVNode("b", null, "Location:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.locs.join(', ') || 'None'), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("b", null, "Department:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.deps.join(', ') || 'None'), 1)
      ]),
      (_ctx.types.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("b", null, "Type:", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.types.join(', ')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _cache[4] || (_cache[4] = _createElementVNode("b", null, "Owner:", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.ownerNames || 'None'), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("b", null, "Version:", -1)),
        _createTextVNode(" V" + _toDisplayString(_ctx.version) + " (editing)", 1)
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "ep-meta-edit" }, [
        _createElementVNode("svg", { viewBox: "0 0 24 24" }, [
          _createElementVNode("circle", {
            cx: "12",
            cy: "12",
            r: "3"
          }),
          _createElementVNode("path", { d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" })
        ]),
        _createTextVNode("Edit details ")
      ], -1))
    ])
  ]))
}